import styled from 'styled-components';
import { Theme } from '../../../../theme/theme';
import { Box } from '../../Box/Box';

export type AccordionButtonVariant = 'default' | 'embedded';

interface Props {
  isActive: boolean;
  theme: Theme;
  variant: AccordionButtonVariant;
}

export const StyledAccordionButton = styled(Box)(({ isActive, variant, theme }: Props) => ({
  display: 'flex',
  alignItems: 'center',
  background: theme.colors.bg,
  cursor: 'pointer',
  width: '100%',
  outline: 'none',
  transition: `background ${theme.transitions.slow}, color ${theme.transitions.slow}`,
  color: theme.colors.neutral['700'],

  ...(variant === 'default' && {
    borderTopLeftRadius: theme.radii.xl,
    borderTopRightRadius: theme.radii.xl,
    borderBottomLeftRadius: isActive ? 0 : theme.radii.xl,
    borderBottomRightRadius: isActive ? 0 : theme.radii.xl,
    minHeight: 64,
    padding: 16,
    color: isActive ? theme.colors.primary['500'] : theme.colors.neutral['700'],
  }),

  ...(variant === 'embedded' && {
    borderRadius: 0,
    padding: '0 12px',
  }),

  '&:hover': {
    background: theme.colors.neutral['50'],
  },

  '&[data-focus-visible-added]:focus': {
    boxShadow: `0px 0px 0px 2px ${theme.colors.primary['300']}, inset 0px 0px 0px 1px ${theme.colors.primary['500']}`,
    zIndex: 1,
  },

  '&::before': {
    content: isActive ? '"\f078"' : '"\f054"',
    fontFamily: '"Font Awesome 5 Pro"',
    fontSize: 16,
    fontWeight: 600,
    marginRight: 8,
    marginLeft: isActive ? -4 : 0,
    color: theme.colors.neutral['500'],

    ...(variant === 'default' && {
      color: isActive ? theme.colors.primary['500'] : theme.colors.neutral['500'],
    }),
  },
}));
